/**
 * Created by Jerker Nord on 2019-06-12.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";

export class ThorReelView extends BaseView {

    private _reelStopDust:TimelineSprite;
    private _reelStopDustTL:TimelineLite;

    constructor(reelId:number) {
        super();
    }

    protected initAnimations():void {
        this._reelStopDust = new TimelineSprite(GameResources.getTextures("reelDust"));
        this._reelStopDust.anchor.set(0.5, 0.5);
        this._reelStopDust.position.set(0, 480);
        this._reelStopDust.alpha = 0;
        this.addChild(this._reelStopDust);

        this._reelStopDustTL = new TimelineLite({paused : true});
        this._reelStopDustTL.add(() => this._reelStopDust.alpha = 1);
        this._reelStopDustTL.add(this._reelStopDust.getAnimation());
        this._reelStopDustTL.add(() => this._reelStopDust.alpha = 0);
    }

    public playReelStopDustAnimation():void {
        this._reelStopDustTL.restart();
    }
}